export default __webpack_public_path__ + "static/media/photo.fb4e69c5.png";